// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchMode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React, { PureComponent } from 'react';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Button from 'share/components/controls/Izenda.Button';
import connect from 'share/enhancers/Izenda.Connect';
import { SEARCH_MODE } from 'logic/data/Izenda.NLQConfigurationConstants';
import ProgressBar from 'share/components/controls/ProgressBar/Izenda.ProgressBar';
import {
  REQUEST_MODE
} from 'logic/data/Izenda.NLQConfigurationConstants';
@connect({ toClass: true })
class SearchMode extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      show: true
    };
  }

  toggleShow = () => {
    this.setState({ show: !this.state.show });
  };

  onClickConfigureSearchMode = () => {
    const { store: { nlqConfigurationModel } } = this.props;
    nlqConfigurationModel.updateRequestMode(REQUEST_MODE.SWITCH);
    nlqConfigurationModel.searchModemessage = 'In Progress';
    nlqConfigurationModel.updateIsProressBar(true);
    
    this.props.store
      .switchConfigureforSearchMode(nlqConfigurationModel.selectedConnection.connectionId,
        nlqConfigurationModel.searchMode)
      .then(data => {
        nlqConfigurationModel.saveNLQConfiguration(data);
      });
  };


  switchSearchMode=(e)=> {
    const { store:{nlqConfigurationModel} } = this.props;
    nlqConfigurationModel.updateSearchMode(e.currentTarget.value);
  };

  render() {
    let localization = this.props.localization;
    const { store:{nlqConfigurationModel} } = this.props;

    let collapseIcon = this.state.show ? 'icon-triangle-down' : 'icon-triangle-right';
    let titleIcon = this.state.show
      ? localization.getText('COMMON_LABEL_COLLAPSE')
      : localization.getText('COMMON_LABEL_EXPAND');
    return (
      <div className='search-mode-wrapper'>
        <div className='u-bgGray u_paddingAll'>
          <a onClick={this.toggleShow.bind(this)}>
            <span title={titleIcon} className={collapseIcon} />
          </a>
          <span>{localization.getText('NLQ_CONFIGURATION_SEARCH_MODE')}</span>     
        </div>
        {this.state.show && (
        <GridLayout className='u-bgWhite u_paddingAll'>
            <div className='search-mode-btn'>
              <Button
                label={localization.getText('COMMON_LABEL_SAVE')}
                onClick={this.onClickConfigureSearchMode}
                 disabled={nlqConfigurationModel.isSwitchDisable}
                className='btn btn-default'
              />
         </div>
        <GridLayout.Row>
          <GridLayout.Col cols={3}>
          <label>
            <input
             type='radio'
             name='searchMode'
             className='search-mode-type'
             value={SEARCH_MODE.GUIDED}
             checked={nlqConfigurationModel.searchMode == SEARCH_MODE.GUIDED}
             onChange={this.switchSearchMode}
            />
            <span className='u_marginLeftInnerSpace'>{localization.getText('NLQ_CONFIGURATION_SEARCH_MODE_GUIDED')}</span> &nbsp;
            </label>
            <label>
            <input
               type='radio'
               name='searchMode'
               className='search-mode-type'
               value={SEARCH_MODE.NATURAL}
               checked={nlqConfigurationModel.searchMode == SEARCH_MODE.NATURAL}
               onChange={this.switchSearchMode}
              />
                <span className='u_marginLeftInnerSpace'>{localization.getText('NLQ_CONFIGURATION_SEARCH_MODE_NATURAL')}</span>
              </label>
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
              {nlqConfigurationModel.requestMode === REQUEST_MODE.SWITCH && <ProgressBar
                isProressBar={nlqConfigurationModel.isProressBar}
                message={nlqConfigurationModel.searchModemessage}
                schemaStatus={nlqConfigurationModel.schemaStatus}
            />}
              </GridLayout.Col>
        </GridLayout.Row>
        </GridLayout>
           )}
      </div>
    );
  }
}
export default SearchMode;



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/SearchMode/Izenda.SearchMode.jsx